import React, {ChangeEvent, useEffect, useState} from 'react'
import style from './profile.module.sass'
// import profileImage from '../../assets/images/sampleUserImage2x.png'
import {ReactComponent as ProfileImage} from '../../assets/svg/sidemenu/userProfile.svg'
import {ReactComponent as Icon} from "../../assets/svg/password.svg";
import {Button} from '../../helpers/commonUi'
import {useDispatch, useSelector} from 'react-redux';
import {Http} from '../../helpers/axois';
import {APIURL} from '../../constant/common';
import _ from 'lodash';
import {useToast} from '../../helpers/commonFunction/useToast';
import {saveDetails} from '../../stateManager/store/user/actions';
import {Input} from 'antd';

const Profile: React.FC = () => {

    const [tabs, setTabs] = useState([ {
        name: 'Preference',
        icon: Icon
    }
    // {
    //     name: 'Change Password',
    //     icon: Icon
    // } 
    ])
    const userDetails = useSelector((state: any) => {
        return state.user.userDetails
    })
    const loggedInUserId = useSelector((state: any) => {
        return state.user.data.user.id
    })
    const socialUserName = useSelector((state: any) => state.user?.data?.user?.userName)
    const [ activeTab, setActiveTab ] = useState<number>(0)
    const [ oldPassword, setOldPassword ] = useState<string>('')
    const [ newPassword, setNewPassword ] = useState<string>('')
    const [ confirmPassword, setConfirmPassword ] = useState<string>('')
    const [showPassCondMsg, setShowPassCondMsg] = useState(false);
    const [showSaveButton, setShowSaveButton] = useState(false);

    // this is for normal sign in 
    const [ firstName, setFirstName ] = useState<string>('')
    const [ lastName, setLastName ] = useState<string>('')

    const {ErrorToast, SuccessToast} = useToast()
    const dispatch = useDispatch()


    useEffect(() => {
        if (userDetails && activeTab === 0) {
            const {firstName, lastName, loginType} = userDetails
            setFirstName(firstName || "")
            setLastName(lastName || "")
            if ((loginType === "google" || loginType === "github")) {
                setTabs(prev => prev.slice(0, prev.length - 1))
            }
        }
    }, [ userDetails, activeTab ])

    useEffect(() => {
        let changedData = {};
        let showButton = false;
    
        if (activeTab === 0) {
            changedData = _.pickBy(
                { firstName, lastName },
                (value, key) => userDetails[key] !== value
            );
            showButton = Object.keys(changedData).length > 0 && !Object.values(changedData).includes("");
        } else {
            showButton = newPassword !== '' || oldPassword !== "" || confirmPassword !== "";
        }

        setShowSaveButton(showButton);
    }, [activeTab, firstName, lastName, oldPassword, newPassword, confirmPassword, userDetails]);


    const updateUser = () => {
        const changed_data = _.pickBy(
            {firstName, lastName},
            (value, key) => userDetails[ key ] !== value
        );
        if (Object.keys(changed_data).length > 0) {
            if (!(Object.values(changed_data).includes(""))) {
                Http.post(`${APIURL}update/${loggedInUserId}/user`, changed_data).subscribe((res: any) => {
                    const {data: {first_name, last_name, user_name, email}, message} = res
                    SuccessToast(message);
                    dispatch(saveDetails({ ...userDetails, firstName: first_name, lastName: last_name, userName: user_name, email}));
                    setShowSaveButton(false)
                }, (err) => {
                    ErrorToast(err.message)
                })
            } else {
                ErrorToast("Fields should not be empty!!")
            }
        }
    }

    const changePassword = () => {
        if (oldPassword === "" || newPassword === "" || confirmPassword === "") {
            ErrorToast("All fields should be filled in!")
        } else if (oldPassword === newPassword) {
            ErrorToast("New password should not be equal to old password")
        } else if (newPassword !== confirmPassword) {
            ErrorToast("New password should be equal to confirm password")
        } else {
            const passCredentials = {oldPassword, newPassword}
            Http.put(`${APIURL}change/${loggedInUserId}/password`, passCredentials).subscribe((res: any) => {
                if (res) {
                    setOldPassword("")
                    setNewPassword("")
                    setConfirmPassword("")
                    setShowSaveButton(false);
                    SuccessToast("Password changed successfully!!")
                }
            }, (err) => {
                ErrorToast(err.message)
            })
        }
    }

    const validationChecklist = () => {
        // validation
        const isBetween_8_to_40 = newPassword.length >= 8 && newPassword.length <= 40;
        const hasUpperCase = /[A-Z]/.test(newPassword);
        const hasLowerCase = /[a-z]/.test(newPassword);
        const hasSpecialCharacter = /[!@#$%^&*()_+{}\[\]:;<>,.?~\-]/.test(newPassword);
        const hasNumber = /\d/.test(newPassword);

        return (
            <>
                <div style={{height: "185px"}} className={`${style.popupBox} zoom-in-animation`}>
                    <div className={style.arrow}></div>
                    <div className={style.insidePopup}>
                        <div className={style.popupTitle} >Must have at least 8 characters.</div>
                        <div style={{borderTop: "0.75px dashed rgba(217, 217, 217, 1)", marginTop: "13px", marginBottom: "13px", height: "2px", width: "100%"}} ></div>
                        <div style={{display: "flex", flexDirection: "column", alignItems: "flex-start"}} >
                            <div style={{marginBottom: "14px", color: "rgba(108, 108, 108, 1)", fontSize: "14px", }} >It's better to have</div>
                            <div style={{marginLeft: "10px", display: "flex", alignItems: "center"}}>
                                <div style={{height: "6px", width: "6px", borderRadius: "25px", background: (hasUpperCase && hasLowerCase) ? "rgba(0, 185, 118, 1)" : "rgba(217, 217, 217, 1)"}}></div>
                                <div style={{marginLeft: "11px", color: (hasUpperCase && hasLowerCase) ? "rgba(0, 185, 118, 1)" : "rgba(108, 108, 108, 1)", fontSize: "14px", }}>Upper & lower case letters</div>
                            </div>
                            <div style={{marginLeft: "10px", display: "flex", alignItems: "center"}}>
                                <div style={{height: "6px", width: "6px", borderRadius: "25px", background: hasSpecialCharacter ? "rgba(0, 185, 118, 1)" : "rgba(217, 217, 217, 1)"}}></div>
                                <div style={{marginLeft: "11px", color: hasSpecialCharacter ? "rgba(0, 185, 118, 1)" : "rgba(108, 108, 108, 1)", fontSize: "14px", }}>A symbol(#$&@!^%*)</div>
                            </div>
                            <div style={{marginLeft: "10px", display: "flex", alignItems: "center"}}>
                                <div style={{height: "6px", width: "6px", borderRadius: "25px", background: hasNumber ? "rgba(0, 185, 118, 1)" : "rgba(217, 217, 217, 1)"}}></div>
                                <div style={{marginLeft: "11px", color: hasNumber ? "rgba(0, 185, 118, 1)" : "rgba(108, 108, 108, 1)", fontSize: "14px"}}>A Number (0-9)</div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }

    return (
        <div className={style.profileContainer}>
            <div className={style.detailsContainer}>
                <div className={style.profileHeader}>
                    {/* <div className={style.image}> */}
                    <ProfileImage height='100px' width='100px' />
                    {/* </div> */}
                    <div className={style.nameDetails}>
                        <span className={style.name} >{(((userDetails?.userName)?.charAt(0))?.toUpperCase() + (userDetails?.userName)?.slice(1)) || (userDetails?.displayName) || (userDetails?.firstName) || "User"}</span>
                        <span className={style.email}>{userDetails?.email}</span>
                    </div>
                </div>
                <div className={style.tabsContainer}>
                    {tabs.map((tab, i) => {
                        const className = `${style.tab} ${(activeTab === i) ? style.active : null}`
                        return (
                            <div key={i} className={className}
                                onClick={() => {
                                    setActiveTab(i);
                                    setShowSaveButton(false);
                                    setNewPassword('');
                                    setOldPassword('');
                                    setConfirmPassword('');
                                }}
                            >
                                <tab.icon></tab.icon>
                                <span data-test-id={`tab_${tab.name}`}>{tab.name}</span>
                            </div>
                        )
                    })}
                </div>
                {
                    (activeTab === 0) ?
                        (
                            <div className={style.formContainer}>
                                {userDetails.loginType !== 'github' && <div className={style.formItem}>
                                    <div className={style.formLabel}>First Name</div>
                                    <input data-test-id="first_name" type='text' disabled={userDetails.loginType === 'google'}
                                        onChange={(event: ChangeEvent<HTMLInputElement>) => setFirstName(event.target.value)}
                                        value={firstName}>
                                    </input>
                                </div>}
                                {!(userDetails.loginType) && <div className={style.formItem}>
                                    <div className={style.formLabel}>Last Name</div>
                                    <input data-test-id="last_name" type='text'
                                        onChange={(event: ChangeEvent<HTMLInputElement>) => setLastName(event.target.value)}
                                        value={lastName} >
                                    </input>
                                </div>}
                                <div className={style.formItem}>
                                    <div className={style.formLabel}>User Name</div>
                                    <input data-test-id="userName" type='text' disabled
                                        value={userDetails?.userName || socialUserName} >
                                    </input>
                                </div>
                                <div className={style.formItem}>
                                    <div className={style.formLabel}>Email</div>
                                    <input data-test-id="email" disabled type='text' value={userDetails?.email}></input>
                                </div>
                            </div>
                        )
                        :
                        (
                            <div className={style.formContainer}>
                                <div className={style.formItem}>
                                    <div className={style.formLabel}>Password</div>
                                    <Input.Password style={{width:"30%", height:"38px", borderRadius:"0px"}} data-test-id="password" type='password' onChange={(e) => setOldPassword((e.target.value).trim())} value={oldPassword}></Input.Password>
                                </div>
                                <div className={style.formItem}>
                                    <div className={style.formLabel}>New password</div>
                                    <Input.Password style={{width:"30%", height:"38px", borderRadius:"0px"}} data-test-id="new_password" type='password' onBlur={() => setShowPassCondMsg(false)} onChange={(e) => {setNewPassword((e.target.value).trim()); setShowPassCondMsg(true)}} value={newPassword}></Input.Password>
                                    {showPassCondMsg && validationChecklist()}
                                </div>
                                <div className={style.formItem}>
                                    <div className={style.formLabel}>Confirm password</div>
                                    <Input.Password style={{width:"30%", height:"38px", borderRadius:"0px"}} data-test-id="confirm_password" type='password' onChange={(e) => {setConfirmPassword((e.target.value).trim());}} value={confirmPassword}></Input.Password>
                                </div>
                            </div>
                        )
                }
                {(showSaveButton && !userDetails.loginType) && <div className={style.actionContainer}>
                    <Button onClick={() => activeTab === 0 ? updateUser() : changePassword()} dataTestId="save" size='small' color='shadow-primary'>SAVE</Button>
                </div>}
            </div>
        </div>
    )
}

export default Profile
